<template>
    <b-col class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm nguồn đồng bộ dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Loại tài sản áp dụng: "
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-model="searchForm.appliedAssetTypeGroupIds"
                                                multiple
                                                class="no-padding"
                                                placeholder="--- Tất cả ---"
                                                :options="assetTypeGroups" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Tên nguồn đồng bộ dữ liệu:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="search"
                                                  placeholder="Nhập tên hoặc mã ..."
                                                  v-model="searchForm.str">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label=""
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <b-grid-tree :searchForm="searchForm"
                                 :gridOptions="gridOptions"
                                 dataUrl="master-data/sync-data-sources"
                                 gridName="Danh sách nguồn đồng bộ dữ liệu"
                                 ref="syncDataSourceTable">
                        <template v-slot:actions>
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(appliedAssetTypeGroupIds)="row">
                            {{ (row.item.appliedAssetTypeGroupNames || []).join(', ') || 'Tất cả' }}
                        </template>
                        <template v-slot:cell(syncDataSourceGroup)="row">
                            {{ $store.getters.getSyncDataSourceGroupName(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button size="sm" :to="{ path: `./${row.item.id}/detail`}" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button size="sm" tag="button" variant="primary"
                                          :to="{ path: `./${row.item.id}/edit` }" title="sửa" class="mr5">
                                    Cập nhật
                                </b-button>
                                <!--<b-button size="sm" @click.stop="remove(row.item.id, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>-->
                            </b-button-group>
                        </template>
                    </b-grid-tree>

                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListSyncDataSource',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    str: null,
                    appliedAssetTypeGroupIds: [],
                },
                syncDataSources: [],
                gridOptions: {
                    fields: [
                        { key: 'id', label: 'ID nguồn đồng bộ', sortable: true },
                        { key: 'name', label: 'Tên nguồn đồng bộ', sortable: true },
                        { key: 'appliedAssetTypeGroupIds', label: 'Loại tài sản áp dụng', sortable: true, groupable: true, groupFormatter: (value, key, item) => (item.appliedAssetTypeGroupNames || []).join(', ') || 'Tất cả' },
                        { key: 'reportRequestUrl', label: 'URL yêu cầu báo cáo', sortable: true },
                    ],
                    sortBy: 'id'
                },
            }
        },
        computed: {
            ...mapState({
                assetTypes: (state, getters) => getters.assetTypeTreeLevel2,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
            }),
        },
        watch: {

        },
        created() {
        },
        methods: {
            search() {
                this.$refs.syncDataSourceTable.refresh();
            },
            loadSyncDataSourceDetail() {
                var vm = this;
                if (this.syncDataSourceSelected) {
                    return this.$services.get(`master-data/sync-data-sources/${this.syncDataSourceSelected || ''}`).done(syncDataSource => {
                        vm.syncDataSource = syncDataSource;
                    });
                } else {
                    vm.syncDataSource = {};
                }
            },
            remove(id) {
                var vm = this;
                if (id) {
                    if (confirm('Bạn có chắc chắn muốn xóa nguồn đồng bộ này?')) {
                        this.$services.delete(`master-data/sync-data-sources/${id}`).done((response) => {
                            vm.$toastr.s('Xóa nguồn đồng bộ dữ liệu thành công !');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn nguồn đồng bộ cần xóa');
                }
            },
        }
    }
</script>
<!--scoped-->
<style scoped>

    .mr5 {
        margin-right: 5px;
    }

    .mt15 {
        margin-top: 15px;
    }

    .border {
        border-radius: 5px;
    }
</style>
